import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import close from '../../../assets/images/close.svg';
import { OFFERS_PAGE_DATA as data } from '../../../api/holi.data.js';
import starAssets from '../../StarPage/imagePage/index.jsx';
import useOnClickOutside from '../../../hooks/useOnClickOutside.js';
import paydayAssets from '../PayDay/payDayImages.js';
import holiFestivalDealsAssets from './HoliFestivalDealsImages.js';
import {
  callFlutterExternalLinkHandler,
  callFlutterHandler,
} from '../../../utils/flutterBridge.js';
import { ctLogV2 } from '../../../utils/cleverTapLogger.utils.js';
import { useIdHash } from '../../../hooks/custom.hooks.js';
import ShimmerSkeleton from '../PayDay/Shimmer/index.jsx';
import { useSelector } from 'react-redux';

function HoliFestivalDeals() {
  const { custId: cid } = useIdHash();
  const [activeTab, setActiveTab] = useState('Online');
  const [activeIndex, setActiveIndex] = useState(null);
  const fqRef = useRef(null);
  const faqScrollRef = useRef(null); // for scrolling
  // const [isLoaded, setIsLoaded] = useState(false);
  const imageLoading = useSelector(
    ({ appReducer }) => appReducer.imagesLoading,
  );

  const handleCategoryClick = (item) => {
    handleEventCall(item);
    faqScrollRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  useOnClickOutside(fqRef, () => {
    setActiveIndex(null);
  });

  useEffect(() => {
    if (cid) {
      logPaydayEvent({
        eventName: 'AppWebpageViewed',
        customerId: cid,
      });
    }
  }, [cid]);

  const logPaydayEvent = ({
    eventName,
    customerId,
    bannerName,
    bannerPosition,
    type,
  }) => {
    ctLogV2({
      eventName: eventName,
      customerId: customerId,
      extraData: {
        source: 'Getaway Deals',
        ...(type && { type }),
        ...(bannerPosition && {
          banner_position: bannerPosition,
        }),
        ...(bannerName && { banner_name: bannerName }),
      },
    });
  };

  const stepData = {
    Online: [
      {
        icon: paydayAssets?.online?.onlinestep1,
        title:
          "Click on the 'Explore' button on the homepage to checkout our partner brands",
        eventName: 'AppWebpageElementClicked',
        type: 'HowtoUseRewards',
        name: 'Online',
      },
      {
        icon: paydayAssets?.online?.ticket,
        title: 'Add your favorites to the cart',
        eventName: 'AppWebpageElementClicked',
        type: 'HowtoUseRewards',
        name: 'Online',
      },
      {
        icon: paydayAssets?.online?.onlinestep3,
        title:
          'At the checkout, select Pay with Rewards to use your points and unlock extra discounts.',
        eventName: 'AppWebpageElementClicked',
        type: 'HowtoUseRewards',
        name: 'Online',
      },
    ],
    Offline: [
      {
        icon: paydayAssets?.offline?.offlinestep1,
        title: 'Walk into our partner Merchant outlet/Store',
        eventName: 'AppWebpageElementClicked',
        type: 'HowtoUseRewards',
        name: 'Offline',
      },
      {
        icon: paydayAssets?.offline?.offlinestep2,
        title: 'At checkout counter, scan the QR code using your TWID App',
        eventName: 'AppWebpageElementClicked',
        type: 'HowtoUseRewards',
        name: 'Offline',
      },
      {
        icon: paydayAssets?.offline?.offlinestep3,
        title: 'Use your reward points to get instant discounts on the bill.',
        eventName: 'AppWebpageElementClicked',
        type: 'HowtoUseRewards',
        name: 'Offline',
      },
    ],
  };
  const steps = stepData[activeTab];

  const twidIntro = [
    {
      img: paydayAssets?.userInfo?.usercount,
      title: '10M+',
      sub_title: 'users',
    },
    {
      img: paydayAssets?.userInfo?.rewardSaved,
      title: '₹100Cr+',
      sub_title: 'Saved',
    },
    {
      img: paydayAssets?.userInfo?.rated,
      title: '4.8★',
      sub_title: 'Rated App',
    },
  ];

  const faqList = [
    {
      question: 'What are Range Barse Savings Barse Deals?',
      answer:
        'Celebrate Holi with festive offers that help you save more on shopping, food, movies, travel, recharges, and more using TWID.',
      eventName: 'AppWebpageElementClicked',
      type: 'FAQ',
      name: 'What are Range Barse Savings Barse Deals?',
    },
    {
      question: 'How long are Range Barse Savings Barse Deals valid?',
      answer: 'The deals will be valid between 27th Feb and 8th March, 2026.',
      eventName: 'AppWebpageElementClicked',
      type: 'FAQ',
      name: 'How long are Range Barse Savings Barse Deals valid?',
    },
    {
      question: 'Where can I use these deals?',
      answer:
        'You can shop across 500+ partner merchants including Swiggy, JioMart, Confirmtkt, BookMyShow, ixigo, Reliance, and many more.',
      eventName: 'AppWebpageElementClicked',
      type: 'FAQ',
      name: 'Where can I use these deals?',
    },
    {
      question: 'How do I redeem my rewards?',
      answer: [
        '<b>Online:</b> Choose your favorite brand → Add your preferred items to cart → Choose Pay with Rewards (TWID UPI) during checkout.',
        '<b>Offline:</b> Walk into a partner store → Shop for essentials → Pay using TWID UPI and earn rewards/save on your purchases with instant discounts.',
      ],
      eventName: 'AppWebpageElementClicked',
      type: 'FAQ',
      name: 'How do I redeem my rewards?',
      renderFormat: 'list',
    },
    {
      question:
        'Can I combine Range Barse Savings Barse Deals with other offers?',
      answer:
        'Yes, in many cases you can combine Range Barse Savings Barse deals with bank/card offers for extra savings. (T&Cs apply)',
      eventName: 'AppWebpageElementClicked',
      type: 'FAQ',
      name: 'Can I combine Range Barse Savings Barse Deals with other offers?',
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleEventCall = (item) => {
    logPaydayEvent({
      eventName: item?.eventName,
      customerId: cid,
      type: item?.type,
      bannerPosition: item?.position,
      bannerName: item?.name,
    });
    if (item?.redirectUrl) {
      if (!item?.inApp) {
        callFlutterExternalLinkHandler('openLinkExternal', {
          url: item?.redirectUrl,
        });
      } else if (item?.inApp) {
        callFlutterHandler('backButton');
      }
    }
  };
  if (imageLoading) {
    return <ShimmerSkeleton />;
  }

  return (
    <div className={styles.pageContainer}>
      <div className={styles.headerSection}>
        <div className={styles.heading}>Offer Details</div>
        <img
          src={close}
          alt="close"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            callFlutterHandler('backButton');
          }}
        />
      </div>
      <div className={styles.contentSection}>
        {/* banner image  done  */}
        <div className={styles.banner}>
          <img
            src={data?.heroBanner?.imageUrl}
            alt="Holi Festival Deals Banner"
          />
        </div>
        {/* categories done */}
        <div className={styles.categoriesSection}>
          <div className={styles.heading}>The Festival of Savings</div>
          <div className={styles.subHeading}>
            This Holi, let your payments play with colours
          </div>
          <div className={styles.img}>
            {data?.holiFestivalDealsCategories?.map((category, index) => (
              <div
                key={index}
                className={styles.category}
                onClick={() => handleCategoryClick(category)}
              >
                <img src={category?.imageUrl} alt={`Category ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        {/* Brands in Spotlight  */}
        <div
          className={styles.brandSplotlightSection}
          style={{
            backgroundImage: `url(${holiFestivalDealsAssets?.bgImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        >
          <div className={styles.heading}>A Splash of Savings This Holi</div>
          <div className={styles.subHeading}>
            Colourful savings from your favourite brands
          </div>
          <div className={styles.img}>
            {data?.holiFestivalDealsBrandsInSpotlight?.map((brand, index) => (
              <div
                key={index}
                className={styles.brand}
                onClick={() => handleEventCall(brand)}
              >
                <img src={brand?.imageUrl} alt={`brand ${index + 1}`} />
              </div>
            ))}
          </div>
          <div className={styles.brandImg}>
            <div className={styles.brandHeading}>OTHER BRANDS</div>
            <div className={styles.imgContainer}>
              {data?.otherBrands?.map((brand, index) => (
                <div
                  key={index}
                  className={styles.brand}
                  onClick={() => handleEventCall(brand)}
                >
                  <img src={brand?.logoUrl} alt={`brand ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* verified */}
        <div className={styles.verifiedSection}>
          {data?.verifiedBy?.map((item, index) => (
            <div key={index} className={styles.verified}>
              <img src={item?.logoUrl} alt={`verified ${index + 1}`} />
            </div>
          ))}
        </div>

        {/* App exclusive deals */}
        <div className={styles.categoriesSection}>
          <div className={styles.heading}>
            Don&apos;t miss the colours of rewards this Holi
          </div>
          <div className={styles.subHeading}>
            More colour. More value. More savings.
          </div>
          <div className={styles.img}>
            {data?.appExclusive?.map((category, index) => (
              <div
                key={index}
                className={styles.category}
                onClick={() => handleEventCall(category)}
              >
                <img src={category?.logoUrl} alt={`Category ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        {/* How to redeem */}
        <div ref={faqScrollRef} className={styles.redeemContent}>
          <div className={styles.title}>How to use Rewards</div>

          <div className={styles.tabs}>
            {['Online', 'Offline'].map((tab) => (
              <button
                key={tab}
                className={`${styles.tab} ${activeTab === tab ? styles.active : ''}`}
                onClick={() => {
                  setActiveTab(tab);
                  handleEventCall(tab);
                }}
              >
                {tab}
              </button>
            ))}
          </div>
          <div className={styles.steps}>
            {steps?.map((step, index) => (
              <div key={index} className={styles.step}>
                <div className={styles.iconWrapper}>
                  <img src={step.icon} alt={`step-${index + 1}`} />
                  {index !== steps.length - 1 && (
                    <div className={styles.dottedLine} />
                  )}
                </div>
                <div className={styles.text}>
                  <div className={styles.stepNumber}>STEP {index + 1}</div>
                  <div className={styles.stepTitle}>{step.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* star intro */}
        <div
          className={styles.introContainer}
          style={{
            backgroundImage: `url(${paydayAssets?.metric})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        >
          <div className={styles.AboutStarContainer}>
            {twidIntro?.map((elem, index) => {
              const isOdd = index % 2 !== 0;
              return (
                <div
                  key={index}
                  className={`${styles.renderCard} ${isOdd ? styles.oddCard : ''}`}
                >
                  <img src={elem.img} alt={elem.title} />
                  <div>{elem?.title}</div>
                  <div>{elem?.sub_title}</div>
                </div>
              );
            })}
          </div>
        </div>

        {/*  Frequent Asked question */}
        <div className={styles.fqContainer}>
          <div className={styles.heading}>Got Questions?</div>
          <div ref={fqRef} className={styles.listContainer}>
            {faqList.map((item, index) => (
              <div key={index} className={styles.section}>
                <div
                  onClick={() => {
                    toggleAccordion(index);
                    handleEventCall(item);
                  }}
                  className={styles.question}
                >
                  <div style={{ width: '85%' }}>{item.question}</div>
                  <img
                    src={starAssets.down}
                    alt="down_img"
                    style={{
                      transform:
                        activeIndex === index
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                      transition: 'transform 0.3s ease',
                    }}
                  />
                </div>
                {activeIndex === index &&
                  (item?.renderFormat === 'list' ? (
                    <ul className={styles.answerList}>
                      {item.answer.map((answerStr, i) => (
                        <li
                          className={styles.answerSpace}
                          key={i}
                          dangerouslySetInnerHTML={{ __html: answerStr }}
                        />
                      ))}
                    </ul>
                  ) : (
                    <div className={styles.answer} style={{ width: '100%' }}>
                      {item.answer}
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HoliFestivalDeals;
